export default {
  title: 'System Logs',
  source: 'Connected to instance: {{instanceId}} · File: {{fileName}}',
  instances: 'Instances',
  localInstance: '{{instanceId}} (connected)',
  instanceLost: 'This instance stopped sending its log (shut down or unreachable)',
  status: {
    connecting: 'Connecting...',
    connected: 'Live',
    disconnected: 'Disconnected',
  },
  searchPlaceholder: 'Filter lines...',
  levels: {
    error: 'Error',
    warn: 'Warn',
    info: 'Info',
    debug: 'Debug',
  },
  httpRequests: 'HTTP requests',
  httpRequestsTitle: 'Show or hide the lines logging the HTTP requests served by the server',
  maxLines: 'Max lines',
  pause: 'Pause',
  resume: 'Resume ({{count}} new)',
  export: 'Export',
  exportTitle: 'Download all the loaded lines (filters not applied) to a text file',
  clear: 'Clear',
  reconnect: 'Reconnect',
  jumpToLatest: 'Jump to latest',
  fileNotFound: 'Instance {{instanceId}}: log file {{fileName}} not found, waiting for it to be created',
  linesCount: 'Showing {{visible}} of {{total}} lines',
  markers: {
    rotated: 'log file rotated',
    skipped: 'too many lines written: some lines skipped',
    truncated: 'older lines not loaded',
  },
}
